import ColumnTypes from '@/utils/ColumnTypes';
function getColums (that) {
    let arr = [
        {
            label: '商品信息',
            key: '',
            type: ()=> import('./tableCells/goodsInfoCell.vue'),
            minWidth: '200',
        },
        {
            label: '店铺信息',
            key: '',
            type: ()=> import('./tableCells/shopInfoCell.vue'),
            width: '180',
        },
        {
            label: '店铺对接人',
            key: 'shop_claim_user_name',
            type: ColumnTypes.TextCell,
            width: '120',
        },
        {
            label: '新对接人',
            key: 'newShopClaimUserName',
            type: ColumnTypes.TextCell,
            width: '120',
        },
        {
            label: '操作',
            key: 'operations',
            type: ColumnTypes.ButtonsCell,
        }
    ]
    return arr;
}

export default getColums;